import React, { useState } from 'react'
import usePost from "Hooks/usePost";

import { createallbooksfromaccounts } from "API/swesum"

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Textfield from "Components/UI/Form/Textfield";

export default function WorkflowCreateAllBooks() {

    const [message, setMessage] = useState("");

    const createallbooksfromaccountsReq = usePost({
        mtnFunc: () => createallbooksfromaccounts(),
        onError: (data) => {
           
            setMessage(data.Message ? data.Message : "Error")
        },
        onSuccess: (data) => {
            
            setMessage(data.Message ? data.Message : "OK")
        },
    });

    return (
        <>
            <Typography variant="h6">
                
            </Typography>
            <Grid container spacing={2} sx={{ mt: 5 }}>
                <Grid item xs={12} sm={6} md={4}>
                    <Textfield
                        multiline
                        label="Meddelande"
                        disabled={true}
                        value={message}
                    />
                </Grid>
            </Grid>

            <Typography sx={{ pb: 1 }}></Typography>
            <Grid
                item
                xs={12}
                md={12}
                sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}
            >
                <Button
                    sx={{ mt: 5 }}
                    onClick={() => createallbooksfromaccountsReq.post()}
                    variant="contained">

                    Starta
                </Button>

            </Grid>
        </>
    )
}
